module.exports = __webpack_public_path__ + "img/fuli66.181535e6.png";